<template>
  <div>
    <v-card v-if="documentos.length">
      <v-toolbar dense flat color="tertiary">
        <v-toolbar-title class="custon-toolbar-title">Listagem de Documentos</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text class="py-0">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Documento
              </th>
              <th width="10%" class="text-center">
                Visualização
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in documentos" :key="item.id">
              <td>{{ item.documento.tipo_documento.nome || '---' }}</td>
              <td class="text-center">
                <v-btn icon>
                  <v-icon
                    color="red accent-4"
                    @click="toggleModalPdf(item.documento.url_documento)"
                  >
                    mdi-file-pdf-outline
                  </v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <PDF />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PDF from '@/views/public/modal/Pdf.vue';

export default {
  name: 'VeiculoDocumentoTable',
  components: {
    PDF,
  },
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
  },
  computed: {
    ...mapState('veiculo', ['data']),
    documentos() {
      return this.data.documentos_veiculo || [];
    },
  },
};
</script>
